import { render, staticRenderFns } from "./FormStatus.vue?vue&type=template&id=27cc3ab2&scoped=true"
import script from "./FormStatus.vue?vue&type=script&lang=js"
export * from "./FormStatus.vue?vue&type=script&lang=js"
import style0 from "./FormStatus.vue?vue&type=style&index=0&id=27cc3ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc3ab2",
  null
  
)

export default component.exports